declare namespace $ {

	type $shm_hitalama_map_widget_entity_form_view__form_shm_hitalama_map_widget_float_form_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form['form'] >
		,
		ReturnType< $shm_hitalama_map_widget_entity_form_view['form'] >
	>
	type $shm_hitalama_map_widget_entity_form_view__map_shm_hitalama_map_widget_float_form_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form['map'] >
		,
		ReturnType< $shm_hitalama_map_widget_entity_form_view['map'] >
	>
	export class $shm_hitalama_map_widget_float_form extends $shm_hitalama_map_widget_float {
		form( ): $shm_hitalama_map_widget_entity_form
		Form( ): $shm_hitalama_map_widget_entity_form_view
		controls( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=form.view.tree.d.ts.map